export enum TypeCesEnum {
  NEW = 'CADASTRAR',
  EDIT = 'EDITAR',
  SHOW = 'VISUALIZAR'
}
